export const FRONTEND_PATH_DEFAULT = '/'
export const FRONTEND_PATH_V2 = '/v2'

export function normalizeFrontendPath(frontendPath) {
  const trimmed = String(frontendPath ?? '').replace(/\/+$/, '')
  return trimmed === FRONTEND_PATH_V2 ? FRONTEND_PATH_V2 : FRONTEND_PATH_DEFAULT
}

export function currentFrontendPath() {
  return normalizeFrontendPath(process.env.BASE_URL)
}

export function shouldSwitchFrontend(frontendPath) {
  return normalizeFrontendPath(frontendPath) !== currentFrontendPath()
}

export function switchFrontend(frontendPath) {
  const target = normalizeFrontendPath(frontendPath)
  window.location.assign(target === FRONTEND_PATH_V2 ? `${FRONTEND_PATH_V2}/` : FRONTEND_PATH_DEFAULT)
}
